import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/hooks/useAuth'
import { getMyProfile } from '@/services/userService'

/**
 * Nome (e foto) da mostrare per l'utente loggato.
 *
 * Per i clienti (USER) la fonte è il profilo `/me`: nome e cognome si cambiano
 * da /user/profile e il claim Cognito `name` resterebbe quello della
 * registrazione. Stesso queryKey di ProfilePage (`['my-profile']`), così il
 * salvataggio lì aggiorna subito menu e saluti. Operatori e admin restano sul
 * claim Cognito.
 */
export function useDisplayName() {
  const { user } = useAuth()
  const isClient = user?.role === 'USER'
  const { data: profile } = useQuery({
    queryKey:  ['my-profile'],
    queryFn:   getMyProfile,
    enabled:   isClient,
    staleTime: 5 * 60_000,
  })

  const fromProfile = isClient
    ? [profile?.firstName, profile?.lastName].map((s) => s?.trim()).filter(Boolean).join(' ')
    : ''
  const name      = fromProfile || user?.name || ''
  const firstName = (isClient && profile?.firstName?.trim()) || name.split(' ')[0] || ''
  const photoUrl  = (isClient && profile?.photoUrl) || ''
  return { name, firstName, photoUrl }
}
